import CustomHttpService from './custom-http.service';
import EncodeDecodeType from '../actiontype/encode-decode-type';
import Config from '../config/config';
import { encryptMessage, fetchPublicKey, readPublicKey, sendOtpApi, verifyOtp} from "./auth.service-utils";
import { LoginAuthConstants, OS_TYPE } from "../constants/app.constant";
import { SentryService } from './sentry-service';

export default class AuthService {
    //Check if user is logged in or not
    static checkIfUserLoggedIn() {
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/profile/unauth/v1/get/login/info";
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    }

    //Check user
    static checkUser(userId) {
        const data = {
            "userid": userId
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/checkuser";
        return CustomHttpService.post(url, data, {}, EncodeDecodeType.ONLINE);
    }

    //generate otp
    static generateOtpApiService = async (userId) => {
        const payload = {
            msisdn: userId,
            otpDigitCount: 4,
            groupId: LoginAuthConstants.WEB_TOKEN_SHORTLIVED,
            os: OS_TYPE,
        };
        const publicKey = await fetchPublicKey();
        const payloadReq = encryptMessage(payload, publicKey);

        const response = await sendOtpApi(payloadReq);
        return response; 
    };

    static validateOtpApiService = async (userId, otp) => {
        const payload = {
            msisdn: userId,
            otpDigitCount: 4,
            dynamicTokenRequired: true,
            otp,
            groupId: LoginAuthConstants.WEB_TOKEN_SHORTLIVED,
            os: OS_TYPE,
        };
        const publicKey = await fetchPublicKey();
        console.log(payload, "payload !!!!", publicKey, "publicKey +++++");
        const payloadReq = encryptMessage(payload, publicKey);
        const response = await verifyOtp(payloadReq);
        return response;
    };

    //auth login
    static authLogin(requestkey) {
        const data = {
            "requestkey": requestkey
        }
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/authapp/v1/authloginget?requestkey=" + data.requestkey;
        return CustomHttpService.get(url, {}, EncodeDecodeType.ONLINE);
    }

    // //fetch user details
    // static fetchSSOProfile() {
    //     let url = Config.baseUrls.HELPSUPPORT.HELPSUPPORT_CONTEXT_URI + "customer/help/support/v1/rtn/fetch";
    //     return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    // }

    //fetch user details
    static fetchSSOProfile() {
        let url = Config.baseUrls.ONLINE.DIGITAL_PROFILE_CONTEXT_URI + "customer/profile/v2/rtn/fetch";
        return CustomHttpService.get(url, {}, EncodeDecodeType.HELPSUPPORT);
    }

    //logout 
    static logout() {
        const logOutLink = "https://www.airtel.in/pkmslogout?redirectURL=https://www.airtel.in/help?source=loginagain";
        window.open(logOutLink, "_self");
    }

}